import {useMutation} from "@tanstack/react-query";
import {rejectCustomerOfferMutationOptions} from "./reject-customer-offer.mutation-options";

export function useRejectCustomerOffer() {
  return useMutation(rejectCustomerOfferMutationOptions());
}
